import React from 'react';

const Sites = () => {
  return <div>Sites Page</div>;
};

export default Sites;
